// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { ProviderAccessPageContext } from '../types/providerAccess';
import './ProviderAccessLayout.css';

interface ProviderAccessLayoutProps {
  context: ProviderAccessPageContext | null;
  children: React.ReactNode;
}

export function ProviderAccessLayout({ children }: ProviderAccessLayoutProps) {
  return (
    <div className="provider-access-layout">
      <main className="provider-access-layout__main">
        <div className="provider-access-layout__content">
          {children}
        </div>
      </main>
    </div>
  );
}
